import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slices/userSlice";
import feedMappingSlice from "./slices/feedMappingSlice";

export const store = configureStore({
  reducer: {
    user: userSlice,
    feedMapping: feedMappingSlice
    // add other reducers here
  },
});
